import { CookieBaseSchema, LocalStorageBaseSchema, LoggerImplement } from "@iflyrpa/share";
import type { CreateAxiosDefaults } from "axios";
import { z } from "zod";
import { SearchAccountInfoResponse } from "./actions/searchAccountInfo/types";

declare module "axios" {
    export interface AxiosRequestConfig {
        defaultErrorMsg?: string;
    }
}

export const ActionParamsSchema = z.object({
    id: z.string().optional(), // steel 任务 id，客户端传入
    // 以下为browser-use中需要携带的参数
    userAgent: z.string().optional(),
    viewport: z
        .object({
            width: z.number(),
            height: z.number(),
        })
        .optional()
        .nullable(),
});

export const ActionCommonParamsSchema = ActionParamsSchema.extend({
    url: z.string().optional(),
    // cookie 必选项
    cookies: z.array(CookieBaseSchema),
    localStorage: z.array(LocalStorageBaseSchema).optional(),
    extraParam: z.any().optional(), // 额外参数，供不同 action 使用
    actionType: z.enum(["mockApi", "rpa", "server"]).optional(),
    accountId: z.number().optional(),
    proxyLoc: z.string().nullable().optional(), // TODO：兼容前端，后期考虑放弃
    localIP: z.string().optional(),
    huiwenToken: z.string().optional(),
    articleId: z.string().optional(),
    saveType: z.string().optional(),
    uid: z.string().optional(),
});

// 自动生成 TypeScript 类型
export type ActiomCommonParams = z.infer<typeof ActionCommonParamsSchema>;

export type AxiosProxyParams = [
    CreateAxiosDefaults, // axios 配置
    LoggerImplement?,
    (string | null | undefined)?, // proxyLoc
    string?, // localIP
    // string?, // huiwenToken
    number?, // accountId
    string?, // platform 业务标识
];

export enum ExecutionState {
    RUNNING = "RUNNING",
    SCAN_WAITING = "SCAN_WAITING",
    SCANNED = "SCANNED",
    CONFIRMED = "CONFIRMED",
    SUCCESS = "SUCCESS",
    TIMEOUT = "TIMEOUT",
    BROWSER_CLOSED = "BROWSER_CLOSED",
    FAILED = "FAILED",
}

export interface FansDetail {
    following: number | null; // 关注数
    fans_count: number | null; // 粉丝数
    digg_count: number | null; // 获赞数
    description: string; // 个人简介
}

export namespace Weixin {
    export interface FansCount extends FansDetail {}

    export interface WeiXinCropResult {
        cdnurl: string;
        file_id: number;
        width: number;
        height: number;
    }
}

export namespace BaiJiaHao {
    export interface FansCount extends FansDetail {}
}
export namespace Toutiao {
    export interface FansCount extends FansDetail {}

    export interface Topic {
        concern_id: string;
        id: string;
        talk_count: string;
        talk_count_str: string;
        type: number;
        word: string;
    }

    export interface SuggestWords {
        user_id: number;
        name: string;
        avatar_url: string;
        followers_count: number;
    }

    export interface CityPoi {
        position: string;
        city: string;
        longitude: number;
        latitude: number;
        type_code: string;
        poi_id: string;
    }

    export interface CityDistrict {
        gps_location: {
            city_name: string;
            city_code: string;
            district_name: string;
            district_code: string;
        };
    }

    export interface UserRight {
        benefit_list: Array<unknown>;
        describe: string;
        fans_num_threshold: number;
        level: number;
        type: number;
    }

    export interface ImageData {
        image_url: string;
        image_uri: string;
        image_width: string;
        image_height: string;
        image_type: string;
        image_mime_type: string;
    }
}

export namespace Xiaohongshu {
    export interface FansCount extends FansDetail {}

    export interface Topic {
        id?: string;
        name: string;
        type: string;
        link?: string;
    }

    export interface Location {
        address: string;
        city_name: string;
        full_address: string;
        latitude: number;
        longitude: number;
        name: string;
        poi_id: string;
        poi_type: number;
        type: string;
    }
}

export const errorResponse = (message: string, code = 500): SearchAccountInfoResponse => ({
    code,
    message,
    data: null,
});

export const MockPublish = false;
export const DisabledReq = false;
